module.exports = __webpack_public_path__ + "img/vip_sign_4.a9b7e41e.png";